<template>
  <div class="predicted-category-sections">
    <div class="sections-label" :class="{ 'cashflow-type-color': !disabled, 'disabled-label': disabled }" v-on:click="toggleExpend()">
      <span class="fa" v-bind:class="{ 'fa-caret-left': !expanded, 'fa-caret-down': expanded, 'out-of-date': outOfDate || disabled }"/>
      <span>{{ title }}</span>
    </div>
    <div class="sections-details">
      <div v-show="expanded">
        <div class="sections-header">
          <div class="header-cell">{{ actualsTitle }}</div>
          <div v-if="showRecommendedTitle" class="header-cell">{{ recommendedTitle }}</div>
        </div>

        <div v-for="category in categories" v-bind:key="category.label">
          <predicted-category-section :label="category.label"
                                      :short-label="category.shortLabel"
                                      :actuals-sum="category.actualsSum"
                                      :showSeparateLine="category.showSeparateLine"
                                      :can-edit-category="isSectionEditable && category.isEditable"
                                      :recommended-amount="category.recommendedAmount"
                                      :show-recommended-amount="showRecommendedTitle"
                                      :transactions="category.transactions"
                                      :initially-expanded="isCategoryInitiallyExpanded(category)"
                                      :disabled="category.disabled || false"
                                      :category-id="category.categoryId"
                                      :time-frame-details="category.timeFrameDetails"
                                      v-on:edit-amount-clicked="$emit('edit-amount-clicked', $event)"
                                      v-on:section-clicked="$emit('section-clicked', $event)">
            <template v-slot:transactions="{ transactions }">
              <slot name="transactions" :transactions="transactions"/>
            </template>
          </predicted-category-section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PredictedCategorySection from './PredictedCategorySection.vue';
import EventBus from '../../../../../../../../../event-bus/event-bus';
import DDLogs from '../../../../../../../../../DDLogs';

export default {
  name: 'PredictedCategorySections',
  components: { PredictedCategorySection },
  props: [
    'actualsTitle',
    'showRecommendedTitle',
    'recommendedTitle',
    'categories',
    'initiallyExpanded',
    'title',
    'sectionsDisabled',
    'outOfDate',
    'isSectionEditable',
    'expenseCategory',
  ],
  data() {
    return {
      expanded: this.initiallyExpanded,
      initialyExpandSubCategories: false,
      subCategoryToExpand: null,
    };
  },
  created() {
    EventBus.$on('expand-category', async ({ categoryToExpand, transactionId, envelopeId }) => {
      if (categoryToExpand === this.expenseCategory) {
        await this.expandToTransaction(transactionId, envelopeId);
      }
    });
  },
  computed: {
    disabled() {
      return !this.categories || _.isEmpty(this.categories) || this.sectionsDisabled;
    },
  },
  methods: {
    toggleExpend() {
      this.initialyExpandSubCategories = false;
      if (!this.disabled) {
        this.expanded = !this.expanded;
        this.$emit('category-sections-clicked', { title: this.title, expanded: this.expanded });
      }
    },
    async expand() {
      this.initialyExpandSubCategories = true;
      this.expanded = true;
    },
    isCategoryInitiallyExpanded(category) {
      return category.initiallyExpanded || this.initialyExpandSubCategories || this.subCategoryToExpand === category.label;
    },
    async expandToTransaction(transactionId, envelopeId) {
      DDLogs.log('Sections: expand to transaction', { transactionId, envelopeId, expenseCategory: this.expenseCategory });
      _.forEach(this.categories, category => {
        const transaction = _.find(category.transactions, t =>
          (t.transactionId && t.transactionId === transactionId) ||
          (t.envelopeId === envelopeId));
        if (transaction) {
          DDLogs.log(
            'Sections: Found transaction in sub-category',
            { transaction, category: category.label, expenseCategory: this.expenseCategory, title: this.title },
          );
          this.subCategoryToExpand = category.label;
        }
      });
      this.expanded = true;
    },
  },
};
</script>

<style scoped lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .predicted-category-sections {
    .sections-label {
      cursor: pointer;
      font-size: 16px;
      font-weight: bold;

      .fa {
        width: 10px;
        color: $riseup_black;
        vertical-align: middle;

        &.out-of-date {
          color: $riseup_gray_2;
        }
      }
    }

    .sections-details {
      margin: 10px 0px;
      box-shadow: 0 1px 3px 0 rgba(155, 155, 155, 0.51);

      .sections-header {
        display: flex;
        padding-right: 100px;
        height: 16px;
        line-height: 16px;
        font-size: 10px;

        .header-cell {
          width: 88px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .disabled-label {
      color: $riseup_gray_2;
      cursor: default;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/generic-components/cashflow-types/cashflow-types-base/PredictedCategorySections.vue